<template>

    <div class="head_container">
        <div class=" flex-col">

            <span class="text_1">看看云医APP</span>
            <span class="text_2">健康服务、轻松云医</span>
            <div class="bt_box flex-row justify-between">

                <a href="https://official.ynkkyy.com/" target="_blank">
                    <div class="text-wrapper_1 flex-col">
                        <span class="text_3">APP简介</span>
                    </div>

                </a>
                    <a href="https://official.ynkkyy.com/" target="_blank">
                <div class="text-wrapper_2 flex-col">
                    <span class="text_4">功能介绍</span>
                </div>
                </a>
            </div>
            <div class="box_14 flex-row justify-between">
                <div class="text-group_7 flex-col justify-between">
                    <span class="text_5">90k&nbsp;+</span>
                    <span class="text_6">Users</span>
                </div>
                <div class="text-group_8 flex-col justify-between">
                    <span class="text_7">32k&nbsp;+</span>
                    <span class="text_8">Daily&nbsp;active</span>
                </div>
                <div class="text-wrapper_13 flex-col justify-between">
                    <span class="text_9">2h&nbsp;+</span>
                    <span class="text_10">Time&nbsp;spent&nbsp;online</span>
                </div>
            </div>



        </div>

        <img class="image_1" referrerpolicy="no-referrer" src="../assets/img/img_app.webp" />
    </div>


</template>

<style scoped>
.head_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1920px;
    height: auto;
    background: url(../assets/img/bg_app.webp);
    background-size: cover;
}
</style>
